import he from 'he';
import { marked } from 'marked';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { versionSelector } from '@/state/config';
// Configure marked for GFM support
marked.use({
    async: true,
    gfm: true,
    breaks: true,
});
export const useMarkdownToHtml = (markdownText) => {
    const [html, setHtml] = useState('');
    const [error, setError] = useState(null);
    const version = useRecoilValue(versionSelector);
    useEffect(() => {
        const convertMarkdownToHtml = async () => {
            try {
                // Backward compatibility for the old editor.
                // Check whether the markdown text includes any raw HTML links.
                if (/<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1/.test(markdownText)) {
                    setHtml(markdownText);
                    return;
                }
                // Decode HTML entities in the input markdownText
                const decodedMarkdown = he.decode(markdownText);
                // Parse markdown to HTML using marked
                const result = await marked.parse(decodedMarkdown);
                setHtml(result);
            }
            catch (err) {
                setError(err);
            }
        };
        convertMarkdownToHtml();
    }, [markdownText, version]);
    return { html, error };
};
